import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import { router } from "./router";
import { brand, applyBrandTheme } from "./brand";
import { initializeTheme } from "./theme";
import "./style.css";

// §5.11 Ф4 — бренд витрины: палитра, заголовок вкладки и цвет вкладки ДО mount.
applyBrandTheme();
initializeTheme();
document.title = brand.tabName;
document.querySelector('meta[name="theme-color"]')?.setAttribute("content", brand.themeColor);

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount("#app");
